import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { SuccessDeleteDialog } from '$components/confirm-delete-dialog/success-delete-dialog';

export interface DeleteNotificationRuleSuccessDialogProps {
  name: string;
  isOpen: boolean;
  onClose: () => void;
}

function Description({ name }: { name: string }) {
  return (
    <Trans
      i18nKey="notificationRules.deleteSuccessDescription"
      values={{ name }}
      components={{ bold: <span className="font-weight-bold" /> }}
    />
  );
}

export function DeleteNotificationRuleSuccessDialog({
  name,
  isOpen,
  onClose,
}: DeleteNotificationRuleSuccessDialogProps) {
  return (
    <SuccessDeleteDialog
      isOpen={isOpen}
      title={t('notificationRules.deleteSuccessTitle')}
      description={<Description name={name} />}
      onClose={onClose}
    />
  );
}
